import { CREATE } from 'react-admin';
export const FORM_DATA = 'FORM_DATA';

import * as constants from '../../constants/index';
import {
    TIME_CHANGE_REQUEST,
    TIME_CHANGE_REQUEST_CLEAR,
    TIME_CHANGE_FLIGHTS_REQUEST,
    TIME_CHANGE_FLIGHTS_REQUEST_CLEAR,
    TIME_CHANGE_FLIGHTS_AFTER_REJECTION,
    TIME_CHANGE_FLIGHTS_AFTER_REJECTION_CLEAR 
} from './types';

export const timeChangeRequest = (data: any) => ({
    type: TIME_CHANGE_REQUEST,
    payload: { data: { flightRequest: data } },
    meta: {
        fetch: CREATE,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FLIGHT_REQUEST.TIME_CHANGE_REQUEST}`,
    },
});

export const timeChangeFlights = (data: any, requestIsChanged?: boolean) => ({
    type: TIME_CHANGE_FLIGHTS_REQUEST,
    payload: { data: data },
    meta: {
        fetch: CREATE,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FLIGHT_REQUEST.TIME_CHANGE_FLIGHTS}`,
    },
});

export const timeChangeFlightsAfterRejection = (data: any) => ({
    type: TIME_CHANGE_FLIGHTS_AFTER_REJECTION,
    payload: { data: data },
    meta: {
        fetch: CREATE,
        resource: `${constants.ROUTES.API_PREFIX}${constants.ROUTES.FLIGHT_REQUEST.TIME_CHANGE_REQUEST_AFTER_REJECTION}`,
    },
});

export const clearTimeChangeRequest = () => ({
    type: TIME_CHANGE_REQUEST_CLEAR,
    payload: [],
});

export const clearTimeChangeFlights = () => ({
    type: TIME_CHANGE_FLIGHTS_REQUEST_CLEAR,
    payload: { data: { result: false } },
});

export const clearTimeChangeFlightsAfterRejection = () => ({
    type: TIME_CHANGE_FLIGHTS_AFTER_REJECTION_CLEAR,
    payload: { data: { result: false } },
});
